$('.cl-preview').on('click',function(e){
  e.preventDefault();
  let $self = $(this);
  let $imgUrl = $self.attr('href');
  let $imgHtml = '<img src='+$imgUrl+' class="cl-preview-image"/>';
  $('.cl-preview-wrapper').html($imgHtml);
  $('.customily-modal-preview-only').addClass('active');
});

$('.customily-close-button').on('click',function(e){
  e.preventDefault();
  $('.customily-modal-preview-only').removeClass('active');
});

$('.upsell_select').on('change', function(){
  const parent = $(this).parents('.upsell.cart__item');
  const url = parent.find('.cart-product-title > a').attr('href');
  const value = this.value;
  if(!url) return;
  $.ajax({
    type: 'GET',
    url: `${url}.json`,
    success(data) {
      const variants = data.product.variants;
      const variant = variants && variants.find(item => item.id == value);
      if(variant.price < variant.compare_at_price){
        parent.find('.cart_meta_prices .modal_price').html(`<span class="money was_price">${variant.compare_at_price}</span> <span class="money">$${variant.price}</span>`);
      }else {
        parent.find('.cart_meta_prices .modal_price').html(`<span class="money">$${variant.price}</span>`)
      }

      // Converting the currencies
      if (window.PXUTheme.currency.show_multiple_currencies) {
        window.currencyConverter._convertAll(window.currencyConverter.currentCurrency)
      }
    },
    error(x, t, m) {
      console.log(x);
      console.log(t);
      console.log(m);
    }
  })
});

let cartRecommendProducts = function(){
  if(!$('.cart-product-list-related')) return;
  let limit = 10;
  let getRecommendProducts = async function(){
    let rPush = [];
    let values = $("#static-cart-recommend").val();
    let arrayRecommendItems = values && values.split(',');

    arrayRecommendItems.forEach(async (i)=>{
      let recommendUrl = `/recommendations/products?section_id=product-recommendations&limit=10&product_id=${i}`;
      rPush.push(new Promise( (rv, rs)=>{
        fetch(recommendUrl)
          .then(response => response.text())
          .then(e => {
            if('undefined' == typeof e){
              rv('');
            }
            else{
              rv(e);
            }
          })
      }))
    })
    return await Promise.all(rPush)
  }
  
  let ie = getRecommendProducts();
  ie.then(e =>{
    let html = '';
    e.map(i=>html += i);
    let parser = new DOMParser();
    html = parser.parseFromString(html, "text/html");

    var productItems = [...html.querySelectorAll('[data-product-item]')];
    let productExist = [];
    if (productItems.length) {
      document.querySelector(".cart-product-list-related").style.display = "block"
      productItems.sort(()=> Math.random() - 0.5);
      let i=0;
      productItems.forEach(function (productItem) {
        let quickHandle = productItem.dataset.productHandle;
        if(!productExist.includes(quickHandle) && i < limit){
          productItem.classList.remove("visible-3");
          productItem.classList.add("visible-5");
          productExist.push(quickHandle);
          document.querySelector('#product-list-related').insertAdjacentHTML('beforeend', productItem.outerHTML);
          i++;
        }
      });
      if(productItems.length > 5){
        var flkty = new Flickity("#product-list-related", {
          // options
          cellAlign: 'left',
          contain: true,
          groupCells: true,
          freeScroll: true,
          wrapAround: true
        });
      }
    }
  });
}

cartRecommendProducts();